import Vue from 'vue'
import VueMoment from 'vue-moment'

const moment = require('moment')
require('moment/locale/id')

Vue.use(VueMoment, {
  moment
})